(function (appComponents) {

	var orderItemCollection = function (parent) {
		var collection = {};
		collection._templates = parent.templates;
		collection._api = parent._api;
		collection._cart = parent._cart;
		collection._product = parent._product;
		collection.elements = {

		};

		var cartItemPrototype = {
			addToCart: function () {
				var self = this;
				var data = {
					pk: self.pk,
					qty: self.quantity,
					spa: self.spaNumber
				};

				collection._cart.addItems([data]);
			},
			downloadDataPack: function (type) {
				collection._product.downloadDataPack(this.product.stockId, type);
			},
			showProductDetails: function () {
				collection._product.showDetails(this.product);
			},
		};

		collection.setCollection = function (items) {

			this.collection = items;
			$.each(this.collection, function (index, el) {
				this._parentElement = $("[pc-container='order-details--item'][pc-value='" + el.entryNumber + "']");
				this.__proto__ = cartItemPrototype;
			});
		};

		collection.findItemByEntryNumber = function (entryNumber) {
			var entryToReturn = null;
			this.collection.forEach(function (el) {
				if (el.entryNumber == entryNumber) {
					entryToReturn = el;
				}
			});
			return entryToReturn;
		};

		return collection;
	};


	if (appComponents.pageComponents == null) appComponents.pageComponents = {};
	if (appComponents.pageComponents.orderDetails == null) appComponents.pageComponents.orderDetails = {};
	appComponents.pageComponents.orderDetails.orderItemCollection = orderItemCollection;

	window.appComponents = appComponents;

})(window.appComponents || {});